import { Form, Select } from 'antd'
import { ColumnProps } from 'antd/lib/table'

import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useColumnSearchProps } from '../../../../../../../components/Table/useColumSearchProps'
import { roleBasedKeyFigureSelector } from '../../../../../../../redux/entities/keyFigures/selectors'
import { KeyFigure } from '../../../../../../../types/keyFigure/KeyFigure'
import { GraphType } from '../../../types'
import DashboardItemFields from '../DasboardItemFieds'
import SelectionTableInput from '../SelectionTableInput'

const KeyFigureChartFields = () => {
  const { t } = useTranslation()
  const selectableKeyFigures = useSelector(roleBasedKeyFigureSelector)

  const columns: ColumnProps<KeyFigure>[] = [
    {
      title: t(`keyFigurePage:key-figure`),
      key: 'id',
      dataIndex: 'id',
      sorter: (a, b) => a.name.localeCompare(b.name),
      ...useColumnSearchProps('id', val => t(`keyFigureStatement:${val.id || val}`))
    }
  ]

  return (
    <>
      <DashboardItemFields />
      <Form.Item label={t('dashboardPage:chart-type')} name={['params', 'representation', 'options', 'type']}>
        <Select
          options={Object.values(GraphType).map(type => ({
            value: type,
            label: t(`dashboardPage:${type}`)
          }))}
        />
      </Form.Item>
      <Form.Item label={t('global:keyFigure')} name={['params', 'keyFigureIds']}>
        <SelectionTableInput<KeyFigure> dataSource={selectableKeyFigures} columns={columns} />
      </Form.Item>
    </>
  )
}

export default KeyFigureChartFields
